import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { Grid, MenuItem, Select, TextField } from '@mui/material';
import { useFormik } from 'formik';
import AddSchema from '../../components/validations/validationsSchema';
import FormInitialValues from '../../components/validations/initalValues';
import { useUtility } from '../../services/utilityContext/useUtility';

// AutoComplete Component Imports
import Checkbox from '@mui/material/Checkbox';
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2, backgroundColor: 'button.menu' }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: 'icon.main',
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

const DialogBox = ({ name, onClose, data, onAddRow, editData, id }) => {
  const [selectedDistributors, setSelectedDistributors] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedValues, setSelectedValues] = useState([]);
  const func = editData && Object.keys(editData).length > 0 ? 'Edit' : 'Add';
  const { city, states, getCities, banks, distributors } = useUtility();

  const handleClose = () => {
    setOpen(false);
    onClose();
  };

  const handleSelectChange = (key, value) => {
    setSelectedValues((prevValues) => ({
      ...prevValues,
      [key]: value,
    }));

    if (key === 'state') {
      const stateId = value;
      getCities(stateId);
    }
  };
useEffect(()=>{
if(selectedValues.state){  getCities(selectedValues.state)}
},[open])
  const handleChange = (event, newValue) => {
    let selectedDistributorID = newValue.map((distributor) => distributor.id);
    handleSelectChange('me_distributor', selectedDistributorID);
    setSelectedDistributors(newValue);
  };

  const formik = useFormik({
    initialValues: FormInitialValues,
    validationSchema: AddSchema(data),
    onSubmit: () => {
      setOpen(false);
      onAddRow(selectedValues, editData[id]);
      onClose();
    },
  });

  useEffect(() => {
    if (editData){ setSelectedValues(editData)
      const filteredRecords = distributors.filter(record => editData?.me_distributor?.includes(record.id));
      setSelectedDistributors(filteredRecords)
    }
    else setSelectedValues([]);
    setOpen(true);
  }, [editData]);
  return (
    <div>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        sx={{
          '& .MuiDialog-paper': {
            backgroundColor: 'background.paper',
            boxShadow: 'none',
            borderRadius: '10px',
            width: '100%',
            maxWidth: '600px',
          },
          '& button.MuiButtonBase-root ': {
            fontFamily: 'Poppins',
            fontSize: 14,
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '22px',
            textTransform: 'capitalize',
            borderRadius: '10px',
            boxShadow: 'none',
            '&:hover': {
              backgroundColor: 'button.menuhover',
              boxShadow: 'none',
            },
          },
        }}
      >
        <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
          {func}&nbsp;
          <span style={{ textTransform: 'capitalize' }}>{name}</span>
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <form onSubmit={formik.handleSubmit} onReset={formik.handleReset}>
            <Grid container spacing={2}>
              {Object.entries(data).map(([key, value]) => {
                if (
                  value.id === 'id' ||
                  value.id === 'is_active' ||
                  value.id === 'actions' ||
                  value.id === 'mechanicTab' ||
                  value.id === 'retailersTab' ||
                  value.id === 'productsTab' ||
                  value.id === 'redeemRequestTab' ||
                  value.id === 'redeemPointsTab' ||
                  value.id === 'permission' ||
                  value.id === 'deleted_at' ||
                  value.id === 'created_at' ||
                  value.id === 'updated_at' ||
                  value.id === 'total_points' ||
                  value.id === 'avaiable_points' ||
                  (editData && Object.keys(editData).length > 0 && value.id === 'password') ||
                  value.id === 'state_name'||
                  func === 'Edit' && value.id === 'pin_code' ||
                  func === 'Edit' && value.id === 'full_name'||
                  name === 'mechanic'&& func === 'Edit' && value.id === 'bank_name'||
                  name === 'mechanic'&& func === 'Edit' && value.id === 'ifsc_code'||
                  name === 'mechanic'&& func === 'Edit' && value.id === 'account_number'
                  ) {
                  return null;
                }

                return (
                  <Grid item xs={12} md={6} key={key}>
                    {value.id === 'me_distributor' ? (
                      <Autocomplete
                        multiple
                        id="checkboxes-tags-demo"
                        options={distributors}
                        disableCloseOnSelect
                        getOptionLabel={(option) => option.name}
                        renderOption={(props, option, { selected }) => (
                          <li {...props}>
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8 }}
                              checked={selected}
                            />
                            {option.name}
                          </li>
                        )}
                        fullWidth
                        value={selectedDistributors}
                        onChange={handleChange}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Select Distributor(s)"
                            placeholder="Distributors"
                          />
                        )}
                      />
                    ) : !['bank_name', 'city', 'state'].includes(value.id) ? (
                      <TextField
                        type={value.id === 'password' ? 'password' : 'text'}
                        required={value.required ? 'required' : ''}
                        placeholder={value.label}
                        fullWidth
                        name={value.id}
                        label={value.label}
                        value={selectedValues[value.id]}
                        error={
                          formik.errors[value.id] && formik.touched[value.id]
                        }
                        helperText={
                          formik.errors[value.id] && formik.touched[value.id]
                            ? formik.errors[value.id]
                            : ''
                        }
                        onBlur={formik.handleBlur}
                        onChange={(event) => {
                          formik.handleChange(event);
                          handleSelectChange(value.id, event.target.value);
                        }}
                        disabled={
                          (editData && Object.keys(editData).length > 0) &&
                          ['contact_number', 'email'].includes(
                            value.id
                          )
                        }
                      />
                    ) : (
                      <Grid item xs={12} md={12}>
                        <Select
                          fullWidth
                          required={value.required ? 'required' : ''}
                          value={selectedValues[value.id] || ''}
                          displayEmpty
                          name={value.id}
                          onChange={(event) =>
                            handleSelectChange(value.id, event.target.value)
                          }
                          // disabled={
                          //   (editData && Object.keys(editData).length > 0) &&
                          //   ['city', 'state'].includes(value.id)
                          // }
                        >
                          <MenuItem value="" disabled>
                            {value.label}
                          </MenuItem>
                          {
                          value.id === 'state'
                            ? states.map((stateOption) => (
                                <MenuItem
                                  key={stateOption.id}
                                  value={stateOption.id}
                                >
                                  {stateOption.name}
                                </MenuItem>
                              ))
                          
                            : value.id === 'city'
                            ? city.map((cityOption) => (
                                <MenuItem
                                  key={cityOption.name}
                                  value={cityOption.name}
                                >
                                  {cityOption.name}
                                </MenuItem>
                              ))
                            : value.id === 'bank_name'
                            ? banks.map((bank) => (
                                <MenuItem key={bank.name} value={bank.name}>
                                  {bank.name}
                                </MenuItem>
                              ))
                            : null}
                        </Select>
                      </Grid>
                    )}
                  </Grid>
                );
              })}
              <Grid item xs={12} md={12}>
                <Button
                  autoFocus
                  fullWidth
                  type="submit"
                  sx={{
                    backgroundColor: 'button.menu',
                    color: 'icon.main',
                    fontFamily: 'Poppins',
                    fontSize: 14,
                    fontStyle: 'normal',
                    fontWeight: 600,
                    lineHeight: '22px',
                    textTransform: 'capitalize',
                    padding: '12px 0px 12px 20px',
                    borderRadius: '10px',
                    boxShadow: 'none',
                    '&:hover': {
                      backgroundColor: 'button.menuhover',
                      boxShadow: 'none',
                    },
                  }}
                >
                  Save
                </Button>
              </Grid>
            </Grid>
          </form>
        </DialogContent>
      </BootstrapDialog>
    </div>
  );
};

export default DialogBox;
